import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTIONS_IMPRESSIONS = gql`
  query campaignOrderTransactionsImpressions($id: ID!) {
    campaignOrderTransactionsImpressionses(where: { transactionWithEvents: { id: $id } }) {
      eventId
      media
      impressionTime
      impressionPublisherPlatform
      impressionPublisherUrl
      impressionPublisher
      impressionPublisherMedia
      impressionPubliserViewed
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTIONS_IMPRESSIONS;
